import { CSSProperties } from "react";

export const notificationContentStyles: CSSProperties = {
  width: "100%",
  display: "flex",
  alignItems: "center",
  justifyContent: "space-between",
  padding: "8px 16px",
};
